import { ApiClientError } from '../api/client';

interface ZodValidationIssue {
  instancePath?: string;
  message?: string;
}

/**
 * Maps a `422 VALIDATION_FAILED` error's `details.issues` (the raw
 * Fastify/zod schema-validation issues - `instancePath: "/fieldName"`,
 * `message`) to a `{ fieldName: message }` map a form can show inline next
 * to the offending input. Returns `{}` for any other error shape (network
 * error, 401, 409, a validation error with no issues, ...).
 */
export function fieldErrorsFromApiError(err: unknown): Record<string, string> {
  if (!(err instanceof ApiClientError)) return {};
  const issues = err.details?.issues;
  if (!Array.isArray(issues)) return {};

  const out: Record<string, string> = {};
  for (const issue of issues as ZodValidationIssue[]) {
    const field = issue.instancePath?.replace(/^\//, '');
    if (field && issue.message && !out[field]) out[field] = issue.message;
  }
  return out;
}
